var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDvSlider3 = function SvgDvSlider3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Slider 3",
    transform: "translate(-30 -49)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 480,
    "data-name": "Rectangle 33688",
    opacity: 0.69,
    rx: 5,
    transform: "translate(30 49)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58427"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb501",
    d: "M716 151h234v46H716z",
    "data-name": "Rectangle 33662"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#171717",
    "data-name": "Go to the Dashboard",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 20,
    fontWeight: 500,
    transform: "translate(833 181)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -104.45,
    y: 0
  }, "Go to the Dashboard")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 30,
    transform: "translate(63 199)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.77,
    y: 0
  }, "TEST")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(58 107)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.08,
    y: 0
  }, "V1.5")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "var list = obj.GetAllRecords(); for (int i = 0; i < list.Rows.Count; i++) { obj.initialize(i); obj.f(\"b5b\").NUMGValid(\"{c0=1}\",\"1:6\",6,6,0,99); }",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(950 269)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -210.27,
    y: 0
  }, "var list = obj.GetAllRecords();"), /*#__PURE__*/React.createElement("tspan", {
    x: -250.23,
    y: 30
  }, "for (int i = 0; i < list.Rows.Count; i++)"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.565,
    y: 60
  }, "{"), /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    x: -107.565,
    y: 90
  }, " obj.initialize(i);"), /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    x: -321.06,
    y: 120
  }, " obj.f(\"b5b\").NUMGValid(\"{c0=1}\",\"1:6\",6,6,0,99);"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.535,
    y: 150
  }, "}"))), /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 480,
    "data-name": "Rectangle 33663",
    opacity: 0.69,
    rx: 5,
    transform: "translate(30 49)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58428",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 836,
    height: 457,
    fill: "#313131",
    "data-name": "Rectangle 33664",
    rx: 5,
    transform: "translate(74 61)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 836,
    height: 68,
    fill: "#434343",
    "data-name": "Rectangle 33665",
    rx: 5,
    transform: "translate(74 61)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434343",
    d: "M119 177h703a5 5 0 0 1 5 5v52H114v-52a5 5 0 0 1 5-5",
    "data-name": "Rectangle 33666"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "Summary Output",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 25,
    transform: "translate(311 100)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -215.225,
    y: 0
  }, "Summary Output")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "Overall Summary",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    opacity: 0.34,
    transform: "translate(274 168)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -155.646,
    y: 0
  }, "Overall Summary")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(174 211)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.082,
    y: 0
  }, "Total")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(386 211)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -87.714,
    y: 0
  }, "Accepted")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(592 211)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -78.588,
    y: 0
  }, "Rejected")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(790 211)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -76.122,
    y: 0
  }, "Warning")), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m882.615 100.76-4.76-4.76 4.76-4.76a1.312 1.312 0 0 0-1.855-1.855l-4.76 4.76-4.76-4.76a1.312 1.312 0 0 0-1.855 1.855l4.76 4.76-4.76 4.76a1.312 1.312 0 0 0 1.855 1.855l4.76-4.76 4.76 4.76a1.312 1.312 0 0 0 1.855-1.855",
    "data-name": "211651_close_round_icon"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9e9e9",
    d: "M114 287h713v1H114z",
    "data-name": "Rectangle 33668",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": 109,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(159 267)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.162,
    y: 0
  }, "109")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": 109,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(350 267)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.162,
    y: 0
  }, "109")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": 0,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(559 267)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.052,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": 0,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(762 267)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.052,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "Rejection Summary",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    opacity: 0.34,
    transform: "translate(294 354)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -174.978,
    y: 0
  }, "Rejection Summary")), /*#__PURE__*/React.createElement("path", {
    fill: "#434343",
    d: "M114 362h713v83H114z",
    "data-name": "Rectangle 33669"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(225 408)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -80.316,
    y: 0
  }, "Question")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "Rejection Count",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(417 396)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41.319,
    y: 0
  }, "Rejection"), /*#__PURE__*/React.createElement("tspan", {
    x: -27.504,
    y: 30
  }, "Count")), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "Respondent Id's",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 18,
    transform: "translate(686 408)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -70.596,
    y: 0
  }, "Respondent Id's")), /*#__PURE__*/React.createElement("rect", {
    width: 836,
    height: 77,
    fill: "#434343",
    "data-name": "Rectangle 33670",
    rx: 5,
    transform: "translate(74 443)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9e9e9",
    d: "M74 443h836v1H74z",
    "data-name": "Rectangle 33671",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 56,
    fill: "#f3b840",
    "data-name": "Rectangle 33672",
    rx: 5,
    transform: "translate(413 456)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 56,
    fill: "#f3b840",
    "data-name": "Rectangle 33673",
    rx: 5,
    transform: "translate(662 456)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1a1a1a",
    "data-name": "Download Excel",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 20,
    transform: "translate(531 491)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -78.1,
    y: 0
  }, "Download Excel")), /*#__PURE__*/React.createElement("text", {
    fill: "#1a1a1a",
    "data-name": "Download Text",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 20,
    transform: "translate(780 491)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -73.41,
    y: 0
  }, "Download Text")), /*#__PURE__*/React.createElement("path", {
    fill: "#5a5a5a",
    d: "M889 129h21v324h-21z",
    "data-name": "Rectangle 33674"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b7b",
    d: "M894 134h11v151h-11z",
    "data-name": "Rectangle 33675"
  })))));
};
export default SvgDvSlider3;